<template>
  <v-layout row wrap>
    <v-flex xs12 sm12 md12>
      <v-toolbar class="primary white--text">
        <v-flex xs12>
          <h2 class=" headline font-weight-light">
            Interest Account
          </h2>
        </v-flex>
        <v-spacer></v-spacer>
        <router-link to="/Dashboard">
          <v-btn icon>
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </router-link>
      </v-toolbar>

      <!-- firm and Date filter -->
      <v-toolbar class="mb" color="white--text" flat>
        <v-layout row>
          <v-flex>
            <v-autocomplete
              dense 
              flat
              clearable
              item-text="name"
              return-object
              :items="firmsByBrand"
              label="Select Firm"
              v-model="selectedFirm"
            ></v-autocomplete>
          </v-flex>
          <v-spacer/>
          
          <v-flex>
            <v-menu
              :close-on-content-click="false"
              v-model="fromdatepicker"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                clearable
                slot="activator"
                v-model="filterInvoiceFrom"
                single-line
                label="From Date"
                readonly
              ></v-text-field>
              <v-date-picker v-model="filterInvoiceFrom" @input="fromdatepicker = false" />
            </v-menu>
          </v-flex>
            
          <v-flex>
            <v-menu
              :close-on-content-click="false"
              v-model="todatepicker"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              >
                <v-text-field
                  clearable
                  slot="activator"
                  v-model="filterInvoiceTo"
                  label="To Date"
                  single-line
                  readonly
                ></v-text-field>
                <v-date-picker v-model="filterInvoiceTo" @input="todatepicker = false" />
              </v-menu>
            </v-flex>
          </v-layout>
        </v-toolbar>
      <!-- End of Firm and Date Filter -->  

      <v-layout row wrap>
        <v-flex xs12>
          <v-data-table
            :headers="invoiceHeader"
            :items="getInvoice"
            class="elevation-1 dashboardHead"
          >
            <template slot="items" slot-scope="props">
              <template v-if="props.item['type'] != 'total'">
                <!-- <td>
                  <b>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</b>
                </td> -->
                <td class="primary--text font-weight-bold" v-html="renderDate(props.item.date)"></td>
                <!-- <td>
                  <b>{{ props.item['.key']}}</b>
                </td> -->
                <!-- <td>
                  <b>{{ props.item['.key']}}</b>
                </td> -->
                <td>
                  <b>{{ getCurrentUserName(props.item.buyerId)}}</b>
                </td>
                <td>
                  <b class="primary--text">{{ props.item.amount || 0 | amount }}</b>
                </td>
                <td>
                  <b class="green--text" v-if="props.item['type']=='LoanGiven'">{{props.item.paidInterest || 0 | amount }}</b>
                  <b class="green--text" v-else-if="props.item['type']=='Opening Balance' && props.item['parentType']=='LoanGiven'">{{props.item.paidInterest || 0 | amount }}</b>
                </td>
                <td>
                  <b class="red--text" v-if="props.item['type']=='LoanTaken'">{{props.item.paidInterest || 0 | amount }}</b>
                  <b class="red--text" v-else-if="props.item['type']=='Opening Balance' && props.item['parentType']=='LoanTaken'">{{props.item.paidInterest || 0 | amount }}</b>
                </td>
                <td>
                  <b class="success--text">{{(Number.parseFloat(props.item.paidInterest) + Number.parseFloat(props.item.amount))|| 0 | amount }}</b>
                </td>
                <td>
                  <b>{{ props.item.paymentType}}</b>
                </td>
                <td>
                  <b>{{getFirmName(props.item.firm)}}</b>
                </td>
              </template>
              <template v-else>
                <td>
                  <b>Total</b>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  <b class="green--text">{{props.item['debit'] || 0 | amount }}</b>
                </td>
                <td>
                  <b class="red--text">{{props.item['credit'] || 0 | amount }}</b>
                </td>
                <td></td>
                <td></td>
              </template>
            </template>
            <template slot="no-data">No Items</template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
export default {
  data() {
    return {
      invoiceHeader: [
        { text: "Date", value: "date", sortable: true },
        // { text: "Invoice Key", value: "key" },
        // { text: "Invoice ID", value: "invoiceId" },
        { text: "Customer Name", value: "name" },
        { text: "PrincipalAmount", value: "principalAmount" },
        { text: "Debit", value: "InterestAmount" },
        { text: "Credit", value: "InterestAmount" },
        { text: "TotalAmount", value: "TotalAmount" },
        { text: "Payment Type", value: "paymentType" },
        { text: "Firm", value: "firmName" },
      ],
      selectedFirm: null,
      filterInvoiceFrom: null,
      filterInvoiceTo: null,
      fromdatepicker: false,
      todatepicker: false,
    };
  },
  created() {
    this.$bindAsObject("firm", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("customerDeposits", this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand))
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear","brandFinYear"]),
    firmsByBrand1() {
      return this.firms
      .filter(item => item["brand"] === this.selectedBrand)
    },
    // current brands firm list
    firmsByBrand () {
      // return selected brand firms
      let firmsB = this.firms
        .filter((item) => item['brand'] === this.selectedBrand)
        firmsB.map((item) => {
          if (item.defaultFirm) {
            this.selectedFirm = item;
          }
        })
      return firmsB;
    },
    getInvoice() {
      let toDate = this.toDate ?  new Date(this.toDate).getTime() : null;
      let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;  
      let invoices = this.customerDeposits.filter(item => {
        // return ((this.selectedFirm ? item['firm'] === this.selectedFirm['.key'] : true) &&
        return ((item["brand"] === this.selectedBrand) && (this.selectedFirm ? item['firm'] === this.selectedFirm['.key'] : true) &&
          (fromDate ? item.date >= fromDate : true) &&
          (toDate ? item.date <= toDate : true) &&
          (item.deleted != true) &&
          (item.date >= this.finYear.start) && (item.date <= this.finYear.end)&& 
          (item["status"] == 'paid' || item["status"] == 'partial') && 
         ((item["type"] === "LoanGiven" || item["type"] === "LoanTaken") || (item["type"] === "Opening Balance" && (item["parentType"] == 'LoanTaken' || item["parentType"] == 'LoanGiven'))))
      });
      return invoices 
    },
  },
  methods: {
    dayDiff(dt1, dt2) {
        return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) ) /(1000 * 60 * 60 * 24));
    },
    getInterest(loan){
      let dayDiff = this.dayDiff(new Date(loan.interestDate),new Date())
      return  this.calculateInterest(loan.amount,loan.interest,dayDiff);
    },
    calculateInterest(P, R, N) {
    var interestRate = ((Number.parseFloat(P) * Number.parseFloat(R)/3000)*N)
    return Number.parseFloat(interestRate).toFixed(2);
    },
    getCurrentUserName(buyerId) {
      let buyer = this.buyerById[buyerId];
      let seller = this.sellerById[buyerId];
      let currentUser =
        buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
      return currentUser.name;
    },
    // getFirmName1(firmId) {
    //   if (this.firm && this.firm[firmId]) {
    //     return this.firm[firmId]["name"];
    //   }
    //   return "--";
    // },
    getFirmName(e) {
      let firm;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(item => item[".key"] === e)[0];
      }
      if (firm) return firm.name;
    },
    renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    },
  },
  watch: {}
};
</script>

<style >
.theme--light div.select-firm .v-icon {
  color: white;
}
.theme--light div.select-firm .v-label {
  color: white;
}
.theme--light div.select-firm .v-input__slot:before {
  border-color: white !important;
}
div.select-firm .v-select__selection--comma {
  color: white;
}

.disabledCard {
  background: lightgray;
}

.ist-datepicker .v-icon,
.ist-datepicker .v-label,
.ist-datepicker input {
  color: white !important;
}

.ist-datepicker .v-input__slot:before {
  border-color: white !important;
}

.fl2-table {
  border-radius: 5px;
  font-size: 12px;
  font-weight: normal;
  border: none;
  border-collapse: collapse;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;
  background-color: white;
}

.fl2-table td,
.fl2-table th {
  text-align: center;
  padding: 8px;
}

.fl2-table td {
  border: 1px solid #000000;
  font-size: 12px;
}

.fl2-table thead th {
  color: #ffffff;
  background: #15155d;
  border: 1px solid white;
}

.fl2-table tr:nth-child(even) {
  background: #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// src/components/InterestAccount/InterestAccounts.vue